import { Injectable } from "@angular/core";
import { AuthenticationService } from "../interfaces/AuthenticationService";
import { jwtDecode } from "jwt-decode";
import { WindowRefService } from "./window-ref.service";

const TOKEN_KEY: string = "PlatformInternalAPITokenJWT";
const OPAQUE_TOKEN_KEY: string = "PlatformInternalAPIToken";
const TOKEN_DETAILS_KEY: string = "PlatformInternalAPITokenJWTDetails";

@Injectable({
  providedIn: "root",
})
export class CurityAuthenticationService implements AuthenticationService {
  constructor(private readonly windowRef: WindowRefService) {}

  getOpaqueToken(): string {
    return localStorage.getItem(OPAQUE_TOKEN_KEY);
  }

  getToken(): string {
    return localStorage.getItem(TOKEN_KEY);
  }

  setToken(token: string): void {
    localStorage.setItem(TOKEN_KEY, token);
  }

  getTokenDetails(): any {
    const details = localStorage.getItem(TOKEN_DETAILS_KEY);
    if (details) {
      return JSON.parse(details);
    } else {
      return null;
    }
  }

  getAccountId(): string {
    if (this.windowRef.nativeWindow["GLOBAL_ACCOUNT"]) {
      return this.windowRef.nativeWindow["GLOBAL_ACCOUNT"].accountId;
    } else {
      return null;
    }
  }

  isEnterprise(): boolean {
    const token = this.decodeToken(this.getToken());
    const accountId = this.getAccountId();
    if (token?.eid && accountId) {
      return token.eid === accountId.toString();
    } else {
      return null;
    }
  }

  getUser(): any {
    const token = this.decodeToken(this.getToken());
    const tokenDetails = this.getTokenDetails();
    const accountId = this.getAccountId();
    if (token && tokenDetails && accountId) {
      return {
        user_id: tokenDetails.userUniqueId,
        user_email: token.sub,
        account_id: accountId,
        account_name: tokenDetails.accountCode,
        account_enterprise: this.isEnterprise(),
      };
    } else {
      return null;
    }
  }

  decodeToken(token: string): any {
    if (token) {
      try {
        return jwtDecode(token);
      } catch (error) {
        console.error("Error decoding token:", error);
        return null;
      }
    } else {
      return null;
    }
  }
}
